import axios from "axios";
const BASE_URL = `${import.meta.env.VITE_BACKEND_API_URL}`;

export const fetchCaseStudies = async () => {
  const res = await axios.get(`${BASE_URL}/admin/case-studies`);
  return res.data.caseStudies || [];
};

export const fetchCaseStudyBySlug = async (slug) => {
  const res = await axios.get(`${BASE_URL}/admin/case-study/${slug}`);
  return res.data.caseStudy;
};
